import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { imageToPicture, PlainImageSection } from '../../components/plain-image/plain-image.component';
import { SectionAttributes, Section, InnerSection, InnerSectionAttributes } from '../../types/section';
import { LinkSection } from '../../types/link';
import { AspectRatio, RouterOrExternalLinkDirective, TemplateTypeDirective } from '@knorr-bremse-portals/ngx-components';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { MarqueeComponent } from '@knorr-bremse-portals/ngx-components/components/marquee';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';
import { NgTemplateOutlet } from '@angular/common';

interface RollingLogoSliderCardAttributes extends InnerSectionAttributes {
  logo: PlainImageSection;
  link?: LinkSection;
  linkText?: string;
  medium?: PlainImageSection;
  text?: string;
}

type RollingLogoSliderCardEditorIds = [
  'link',
  'linkText',
  'logo',
  'medium',
  'text',
];

type RollingLogoSliderCardSection = InnerSection<RollingLogoSliderCardAttributes, RollingLogoSliderCardEditorIds, 'rolling-logo-slider-card'>;

type RollingLogoSliderSection = Section<
  {
    headline: string;
    cards: RollingLogoSliderCardSection[];
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'cards',
  ],
  'rolling-logo-slider'
>;

@Component({
    selector: 'app-rolling-logo-slider',
    styleUrls: ['./rolling-logo-slider.component.scss'],
    templateUrl: './rolling-logo-slider.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        CardComponent,
        StandaloneLinkComponent,
        MarqueeComponent,
        PictureComponent,
        RouterOrExternalLinkDirective,
        FsButtonComponent,
        TemplateTypeDirective,
        NgTemplateOutlet,
    ],
})
export class RollingLogoSliderComponent extends SectionComponent<RollingLogoSliderSection> {

  protected imageToPicture = imageToPicture;

  protected originalAspectRatio = AspectRatio.Original;

  protected standardAspectRatio = AspectRatio.Standard;

  protected cardTemplateType!: {
    card: RollingLogoSliderCardSection;
  }

}
